import { TAB_BAR_ICON_DICTIONARY } from './constants';
import iconDictionary from '../../../../../utils/iconDictionary';

const IconGenerator = ({ name }, focused) => {
  const iconState = focused ? 'active' : 'default';
  return iconDictionary(TAB_BAR_ICON_DICTIONARY[iconState][name], { iconState });
};

export default IconGenerator;
